export default {
  endpointHost: 'https://falcon-api.staging.aws.ucastme.de',
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  serverEnv: process.env.REACT_APP_SERVER_ENV,
};
